var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4393 6.27235C16.3677 6.26073 16.2953 6.25537 16.2228 6.25631H3.88358L4.15264 6.13117C4.41564 6.00669 4.6549 5.83728 4.8597 5.63059L8.31993 2.17036C8.77565 1.73533 8.85222 1.0355 8.50139 0.512206C8.09307 -0.0454281 7.31002 -0.166505 6.75235 0.241817C6.7073 0.274823 6.66447 0.310802 6.62423 0.349518L0.367034 6.60672C-0.121966 7.09517 -0.122396 7.88753 0.366056 8.37653C0.366369 8.37684 0.366721 8.37719 0.367034 8.3775L6.62423 14.6347C7.11362 15.1227 7.90598 15.1216 8.39404 14.6322C8.43244 14.5937 8.46831 14.5527 8.50139 14.5096C8.85222 13.9863 8.77565 13.2864 8.31993 12.8514L4.86596 9.38491C4.68235 9.20111 4.47125 9.04698 4.24024 8.92814L3.86481 8.75919H16.1539C16.7932 8.78293 17.3541 8.33636 17.4742 7.70798C17.5848 7.02575 17.1215 6.38302 16.4393 6.27235Z",
    fill: "#491f69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleArrow);
export default __webpack_public_path__ + "static/media/purpleArrow.50f897eb74070f9f38125589c82538ca.svg";
export { ForwardRef as ReactComponent };